import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import AssignmentRowProcessed from "./AssignmentRowProcessed";
import AssignmentRowUnprocessed from "./AssignmentRowUnprocessed";

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
            invoices: props.invoices,
            supplierRules: props.supplierRules,
            vatCollectorCodes: props.vatCollectorCodes,
            showProcessedItems: false,
        };
        this.store = Store;
    }

    createRule = (event, ruleData) => {
        api.post('supplier/' + this.state.config.company_id + '/rule/add', ruleData)
            .then((response) => {
                this.props.updateRules(response.data.supplierRules);
            })
            .catch((error) => {
                if (error.response && error.response.status === 422) {
                    this.props.notifyError(error.response.data.message)
                    return;
                }

                this.props.notifyError('Hiba történt a szabály létrehozása során. (#2002)')
            })
    }

    deleteInvoiceItem = (keyIndex) => {
        let indexes = keyIndex.split("-");
        let invoices = this.state.invoices;

        delete invoices[indexes[0]].items[indexes[1]];
        invoices[indexes[0]].items = invoices[indexes[0]].items.filter(Boolean);

        if (invoices[indexes[0]].items.length === 0) {
            delete invoices[indexes[0]];
            invoices = invoices.filter(Boolean);
        }

        this.props.updateInvoices(invoices, this.state.supplierRules);
    }

    deleteInvoice = (invoiceIndex) => {
        let invoices = this.state.invoices;
        delete invoices[invoiceIndex];
        invoices = invoices.filter(Boolean);
        this.props.updateInvoices(invoices, this.state.supplierRules);
    }

    removeRemainingInvoices = () => {
        let invoices = this.state.invoices;

        for (let invoiceIndex in invoices) {
            for (let itemIndex in invoices[invoiceIndex].items) {
                if (!invoices[invoiceIndex].items[itemIndex].main_bookkeeping_number) {
                    delete invoices[invoiceIndex].items[itemIndex];
                }
            }

            invoices[invoiceIndex].items = invoices[invoiceIndex].items.filter(Boolean);
        }

        for (let invoiceIndex in invoices) {
            if (invoices[invoiceIndex].items.length === 0) {
                delete invoices[invoiceIndex];
            }
        }

        invoices = invoices.filter(Boolean);

        this.props.updateInvoices(invoices, this.state.supplierRules);
        this.props.nextStep();
    }

    listInvoices = () => {
        let invoices = [];
        let self = this;

        this.state.invoices.map(function (invoice, invoiceIndex) {
            invoice.items.map(function (invoiceItem, invoiceItemIndex) {
                if (invoiceItem.main_bookkeeping_number) {
                    console.log(0)
                    return;
                }
                console.log(1)
                let id = invoiceIndex + '-' + invoiceItemIndex + '-' + Math.random(9999, 99999);
                invoices.push(
                    <AssignmentRowUnprocessed
                        key={id}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        invoiceIndex={invoiceIndex}
                        keyIndex={id}
                        vatCollectorCodes={self.state.vatCollectorCodes}

                        onCreateRule={(event, ruleData) => self.createRule(event, ruleData)}
                        deleteInvoiceItem={(keyIndex) => self.deleteInvoiceItem(keyIndex)}
                        deleteInvoice={(invoiceIndex) => self.deleteInvoice(invoiceIndex)}
                        notifySuccess={(msg) => this.props.notifySuccess(msg)}
                        notifyError={(msg) => this.props.notifyError(msg)}
                    />
                );
            });
        });
        return invoices;
    }

    listProcessedInvoices = () => {
        let invoices = [];
        let self = this;
        this.state.invoices.map(function (invoice, invoiceIndex) {
            invoice.items.map(function (invoiceItem, invoiceItemIndex) {
                if (!invoiceItem.main_bookkeeping_number) {
                    return;
                }
                let id = invoiceIndex + '-' + invoiceItemIndex + '-' + Math.random(9999, 99999);
                invoices.push(
                    <AssignmentRowProcessed
                        key={id}
                        invoice={invoice}
                        invoiceItem={invoiceItem}
                        keyIndex={invoiceIndex + '-' + invoiceItemIndex}
                        invoiceIndex={invoiceIndex}
                        itemIndex={invoiceItemIndex}
                        config={self.state.config}

                        onSetBookKeepingNumber={(invoiceIndex, itemIndex, main_bookkeeping_number) => self.onSetBookKeepingNumber(invoiceIndex, itemIndex, main_bookkeeping_number)}
                        deleteInvoiceItem={(keyIndex) => self.deleteInvoiceItem(keyIndex)}
                        deleteInvoice={(invoiceIndex) => self.deleteInvoice(invoiceIndex)}
                        notifySuccess={(msg) => this.props.notifySuccess(msg)}
                        notifyError={(msg) => this.props.notifyError(msg)}
                    />
                );
            });
        });
        return invoices;
    }

    onSetBookKeepingNumber = (invoiceIndex, itemIndex, main_bookkeeping_number) => {
        let invoices = this.state.invoices;
        this.state.invoices[invoiceIndex].items[itemIndex].main_bookkeeping_number_custom = main_bookkeeping_number;
        this.props.updateInvoices(invoices, this.state.supplierRules);
    }

    showHideProcessedItems = () => {
        this.setState({showProcessedItems: !this.state.showProcessedItems});
    }

    hasUnprocessedInvoices = () => {
        let unprocessed = false;
        this.state.invoices.map(function (invoice) {
            invoice.items.map(function (invoiceItem) {
                if (!invoiceItem.main_bookkeeping_number) {
                    unprocessed = true;
                }
            });
        });
        return unprocessed;
    }

    render() {

        if (!this.state.invoices) {
            return (
                <div className='col-lg-12 text-center margin-top-50'>
                    <p>Nincs feldolgozandó számla a lekérésben!</p>
                </div>
            );
        }

        return (
            <section id='supplier-assignment'>
                <div className='container-fluid'>

                    <div className='row'>
                        <div className='col-md-6 offset-md-6'>
                            <ul className='legend'>
                                <li><i className='fa fa-dot-circle-o' aria-hidden='true'></i> <span className=''>{i18.SUPPLIER._createRulesAndProcess}</span></li>
                                <li><i className='padding-left-20 fa fa-check-circle' aria-hidden='true'></i> <span className=''>{i18.SUPPLIER._oneTimeProcessing}</span></li>
                            </ul>
                        </div>
                    </div>

                    {this.hasUnprocessedInvoices()
                        ? <table className='table table-striped table-aibook-no-border'>
                            <thead>
                            <tr>
                                <th>Szállító neve</th>
                                <th>Bizonylatszám</th>
                                <th>Tétel megnevezés</th>
                                <th>Főkönyv szám</th>
                                <th>ÁFA százalék</th>
                                <th>ÁFA gyüjtő kód</th>
                                <th>ÁFA fők. szám</th>
                                <th style={{width: '130px'}}/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listInvoices()}
                            </tbody>
                        </table>
                        : <div className='text-center margin-top-50 margin-bottom-50'>
                            <p>Minden számlához sikerült szabályt rendelni.</p>
                            <a onClick={() => this.props.nextStep()} className='next-step'>{i18.BUTTONS._goToDownload}</a>
                        </div>
                    }

                    <div className='next-step-btn-container margin-top-50 margin-bottom-50 text-left'>
                        <a onClick={() => this.showHideProcessedItems()} className='next-step'>{this.state.showProcessedItems ? i18.BUTTONS._hideProcessedItems : i18.BUTTONS._showProcessedItems}</a>

                        {this.hasUnprocessedInvoices()
                            ? <a onClick={() => this.removeRemainingInvoices()} className='pull-right table-gray-btn'>Maradék tételek kihagyása</a>
                            : null}
                    </div>

                    {this.state.showProcessedItems
                        ? <table className='table table-striped table-aibook-no-border'>
                            <thead>
                            <tr>
                                <th>Szállító neve</th>
                                <th>Bizonylatszám</th>
                                <th>Tétel megnevezés</th>
                                <th>Főkönyv szám</th>
                                <th>ÁFA százalék</th>
                                <th>ÁFA gyüjtő kód</th>
                                <th>ÁFA fők. szám</th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listProcessedInvoices()}
                            </tbody>
                        </table>
                        : null
                    }
                </div>
            </section>
        );
    };
}

export default Assignment


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment.js